<template>
  <div class="campaigns">
    <div class="inner-content">
      <div v-if="confirmed">
        <h1>Вие се регистрирахте успешно!</h1>
        <p>Можете да влезете в акаунта си <router-link to="/вход">тук</router-link>.</p>
      </div>

      <div v-else>
        <h1>Регистрацията Ви беше изпратена успешно.</h1>
        <p>За да можете да влезете в профила си, е нужно да потвърдите електронната си поща като кликнете върху линка, който ще Ви изпратим.</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SuccessfulRegistration',

  computed: {
    confirmed () {
      return this.$route.meta.confirmed
    }
  }
}
</script>
